var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "profile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.95 11.25a6.664 6.664 0 0 1 1.925-.942A7.339 7.339 0 0 1 8 10c.733 0 1.442.103 2.125.308.683.206 1.325.52 1.925.942.389-.456.678-.961.867-1.517A5.347 5.347 0 0 0 13.2 8c0-1.44-.507-2.668-1.52-3.68C10.666 3.305 9.438 2.8 7.996 2.8c-1.442 0-2.668.506-3.68 1.52C3.307 5.331 2.8 6.56 2.8 8c0 .6.095 1.178.283 1.733.19.556.478 1.061.867 1.517ZM8 9.2a2.314 2.314 0 0 1-1.7-.7 2.314 2.314 0 0 1-.7-1.7c0-.667.233-1.233.7-1.7A2.314 2.314 0 0 1 8 4.4c.667 0 1.233.233 1.7.7.467.467.7 1.033.7 1.7s-.233 1.233-.7 1.7c-.467.467-1.033.7-1.7.7Zm.005 5.2a6.25 6.25 0 0 1-2.488-.5 6.453 6.453 0 0 1-2.042-1.375A6.454 6.454 0 0 1 2.1 10.484a6.255 6.255 0 0 1-.5-2.492 6.2 6.2 0 0 1 .5-2.484A6.453 6.453 0 0 1 5.516 2.1a6.255 6.255 0 0 1 2.492-.5 6.2 6.2 0 0 1 2.484.5A6.477 6.477 0 0 1 13.9 5.512c.333.775.5 1.603.5 2.483 0 .881-.167 1.71-.5 2.488a6.451 6.451 0 0 1-3.412 3.417c-.775.333-1.602.5-2.483.5ZM8 13.2c.578 0 1.133-.092 1.667-.275a5.317 5.317 0 0 0 1.5-.808 6.001 6.001 0 0 0-1.517-.684A5.865 5.865 0 0 0 8 11.2c-.567 0-1.12.075-1.658.225-.54.15-1.042.38-1.509.692.467.355.967.625 1.5.808A5.092 5.092 0 0 0 8 13.2ZM8 8c.333 0 .617-.117.85-.35.233-.233.35-.517.35-.85 0-.333-.117-.617-.35-.85A1.157 1.157 0 0 0 8 5.6c-.333 0-.617.117-.85.35-.233.233-.35.517-.35.85 0 .333.117.617.35.85.233.233.517.35.85.35Z",
    fill: "#404040"
  }))));
};
export default SvgProfile;